import churchsoutheast from '../images/churchsoutheast.jpg'

css .history-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
	.history
		flg: 1

tag history-page
	<self.history-page>
		<shape-header title="History" image=churchsoutheast>
		<text-block.history title="A Brief History">
			<p[mb:1em]>
				"Grace Lutheran Church has been a very visible and prominent part of Downtown San Antonio for more than 100 years. The present church building was dedicated in 1929 and includes Gothic architecture, stained glass windows designed by Gaytee Studios in Minneapolis, Minnesota, a Baptismal Font designed and made by San Antonio native Waldine Tauch who was a student of Pompeo Coppini Studios in New York City, and a altar carving of the Last Supper reported to have come from Germany."
			<p[mb:1em]>
				"Grace was established in 1903 by a small group of Lutherans who wanted to have services conducted in English. It has a long history of being involved in community activities serving the needs of San Antonio. In 1913 Grace Lutheran Sanitorium was established to fight the Tuberculosis problem of that time."
			<p[mb:1em]>
				"Since then, there have been literally dozens of needs supported, many of which are still active today. Grace provides the buildings for Christian Assistance Ministry (CAM) Headquarters and now lets Corazon Ministries use our facilities during the week to provide help to the homeless. Grace was involved in the establishment of San Antonio Metropolitan Ministries (SAMM) which provides a \"Haven for Hope\" for the needy in the city."
			<p[mb:1em]>
				"Grace also continues support of Meals on Wheels, Habitat for Humanity, and Grace Quilters who have shipped more than 4,000 quilts to Lutheran World Relief since they started in 2002."
			<p[mb:1em]>
				"An interesting side note about the beauty of the sanctuary is that in 2012 Grace was included in two books. One was titled "
				<strong> "Spiritual Treasures of Downtown San Antonio"
				" and the other was titled "
				<strong> "Images of America - San Antonio Churches."
			<p[mb:1em fs:smaller]>
				<em>
					"This history was submitted by our beloved historian, Craig Johnson, who we remember with love and gratitude."
		<footer-section>